var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.517 7.103H22.642c-.902 2.275-1.574 5.143-2.054 8.073a82.875 82.875 0 00-.883 7.906c.883.03 2.19.053 4.077.053h1.72l.037 1.721a79.9 79.9 0 00.21 4.318 17.729 17.729 0 007.824-3.746l2.262 2.695a21.271 21.271 0 01-9.712 4.564c.137.995.285 1.852.43 2.557h12.964V7.104zM22.253 29.56l-.323.002c-4.703 0-8.94-1.713-12.02-4.458L7.571 27.73c3.729 3.324 8.797 5.35 14.359 5.35.232 0 .464-.004.694-.01.11.792.226 1.519.347 2.175H4.342V7.104h14.556c-.799 2.356-1.37 4.994-1.782 7.502a86.765 86.765 0 00-1.01 9.864 1.766 1.766 0 00.767 1.723 1.776 1.776 0 00.684.27c.095.017.2.03.287.038.199.021.503.044.955.065.68.034 1.724.065 3.279.08a76.18 76.18 0 00.175 2.913zM4.342 3.587A3.518 3.518 0 00.824 7.103v28.14a3.517 3.517 0 003.518 3.518h35.175a3.517 3.517 0 003.518-3.517V7.104a3.517 3.517 0 00-3.517-3.518H4.341zm6.201 14.745v-5.276h3.518v5.276h-3.518zm18.515-5.276v5.276h3.518v-5.276h-3.518z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/mac-icon.99b7c7934edb7e37331d0e6eee6122e6.svg";
export { ForwardRef as ReactComponent };